let cached: boolean | null = null;

/**
 * ECharts paints onto a canvas. jsdom returns null from getContext('2d') unless the optional `canvas`
 * package is installed, so probing once lets the chart components skip the visual layer under test
 * without a test-only branch or a module mock. The result cannot change within a page's lifetime, so
 * it is memoized — the probe also emits a jsdom "Not implemented" warning, and once per module load is
 * enough.
 */
export function canRenderCanvas(): boolean {
  if (cached !== null) return cached;
  try {
    cached = document.createElement('canvas').getContext('2d') !== null;
  } catch {
    cached = false;
  }
  return cached;
}
